var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status",class:{noting:_vm.isNoting}},[_c(_vm.statusComponent,{tag:"component",attrs:{"msg":_vm.displayMsg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }